import { EXTERNAL_API_BASE } from '../constants';
import { useFetch, usePost, formatQueryError } from '../utils/queries';

function useGetApiKeySettings(_, options = {}) {
  const context = useFetch({
    key: ['API_KEY_SETTINGS'],
    url: `${EXTERNAL_API_BASE}/settings`,
    reactQueryConfig: options,
  });
  return {
    ...context,
    error: formatQueryError(context),
  };
}

function useRegenerateApiKey(_, options = {}) {
  const context = usePost({
    url: `${EXTERNAL_API_BASE}/settings/regenerate`,
    reactQueryConfig: {
      invalidateKeys: () => [['API_KEY_SETTINGS']],
      ...options,
    },
  });
  return {
    ...context,
    error: formatQueryError(context),
  };
}

export { useGetApiKeySettings, useRegenerateApiKey };
